// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c175b917","400":"d991091f","455":"8595ccad"}[chunkId] + ".chunk.js";
};